/** @format */
import Master from '../../Layouts/Master';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../../Shared/hooks/api/Index';
import { error, success } from '../../../Shared/Components/Toast';
import { useContext } from 'react';
import { EventContext } from '../../../Contexts/EventContext';
import { useEffect } from 'react';
import Loading from '../../../Shared/Components/Loading';

const validationSchema = Yup.object().shape({
	name: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
	description: Yup.string()
		.required('توضیحات الزامی است')
		.max(190, 'توضیحات نمیتواند بیشتر از 190 کاراکتر باشد'),
});

const CreateRole = () => {
	const navigate = useNavigate();
	const [submitFormLoading, setSubmitFormLoading] = useState(false);
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getRole();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	const getRole = async () => {
		setLoading(true);
		await useApi.get(
			`/panel/role/${id}`,
			{},
			(res) => {
				eventContext.role = res.data.data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('خطایی درهنگام دریافت اطلاعات پیش آمده است.');
			},
		);
	};

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.put(
			`/panel/role/${id}`,
			values,
			(res) => {
				success('نقش با موفقیت ایجاد شد');
				navigate('/panel/admin/roles', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					name: eventContext.role?.name,
					description: eventContext.role?.description,
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded mt-3'>
							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان</label>
										<input
											name='name'
											value={values.name}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.name} />
									</div>
								</div>
							</div>
							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>توضیحات</label>
										<input
											name='description'
											value={values.description}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.description} />
									</div>
								</div>
							</div>
							<div className='col-12'>
								<div className='d-flex flex-row justify-content-end'>
									<button className='btn btn-info btn-sm f-14'>
										{submitFormLoading ? (
											<div
												className='spinner-border spinner-border-sm text-white mb-1'
												role='status'></div>
										) : (
											'ثبت نقش'
										)}
									</button>
								</div>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default CreateRole;
